import { createCrudHooks } from "../common/queries";

export const studentApi = createCrudHooks({
	baseKey: "students",
	basePath: "/students",
	getAllParams: { include: [{ association: 'enrollments' }, { association: 'ratings' }] },
	getParams: { include: { association: 'enrollments', include: [{ association: 'course', include: ['subject'] }] } },
});
